export const getMerchCartQueryVariables = (ids: string[]) => ({
	filter: {
		product: {
			id: {
				_in: ids,
			},
		},
	},
});
